import styled from 'styled-components';

import { blockquoteTokens } from '../../tokens/components/Blockquote/tokens';

/* @internal */
export const BlockquoteWrapper = styled.blockquote`
  margin: 0 0 0 ${blockquoteTokens.SpacingHorizontalLeft};
  padding-left: ${blockquoteTokens.SpacingHorizontalRight};
  border-left-width: ${blockquoteTokens.BorderWidthDefault};
  border-left-style: ${blockquoteTokens.BorderStyleDefault};
  border-left-color: ${blockquoteTokens.BorderColorDefault};
`;
